import React, { useEffect, useState } from "react";
import { Layout, FormParser,PopupModal } from "../Components";
import { NavLink,useParams } from "react-router-dom";
import Masters from "../Components/masters.json"
import "./Pages.css"
import axiosConfig from "../Service/axiosConfig"
const CountryEdit = () => {
    const[Error,SetError]=useState("")
    const[popupType,setpopupType]=useState("")
    const MastersModal=Masters.Country
    const formSubmit=(Data)=>{
        axiosConfig.put(`/masters/countries/${id}/`,Data).then(res=>{
                   console.log(res)
                   setpopupType("success")
        }).catch(error=>{
            console.log(error.response.data.country_name)
            if(error.response.data.country_name[0]==="This field is required."){
                 SetError("Enter country name")
            }
            if(error.response.data.country_name[0]==="Enter a valid country name."){
                SetError("Enter a valid country name.")
           }
           if(error.response.data.country_name[0]==="already exists"){
            SetError("Country Already Exists.")
           }
           if(error.response.data.country_name[0]==="This field may not be blank."){
            SetError("Enter country name")
           }
            
            setpopupType("error")
        })
      }
    let { id } = useParams();
    const [Data, SetData] = useState([])
    const GetData = async () => {
        try {
            const responce = await axiosConfig.get(`/masters/countries/${id}/`)
            SetData(responce.data)
        }
        catch (error) {
            console.log(error)
            
        }

    }
    useEffect(() => {
        GetData();
    }, [])
    return (
        <>
            <Layout>
                <div className="dashboard-header">
                    <h5 className="dashboard-subtitle">Edit Country {id}</h5>
                    <NavLink to="/dashboard/masters/countries" ><button className="btn btn-white">Manage</button></NavLink>
                </div>
                <FormParser modelObject={MastersModal} formData={Data} formSubmit={formSubmit} error={Error}/>
                {popupType != "" &&
                    <PopupModal popupType={popupType} Navigation="/dashboard/masters/countries"/>
                }
            </Layout>
        </>
    )

}
export {CountryEdit}